import { render, staticRenderFns } from "./StoreAutomationsForm.vue?vue&type=template&id=5985ae68&"
import script from "./StoreAutomationsForm.vue?vue&type=script&lang=js&"
export * from "./StoreAutomationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports